import user, { isSelf, UserModel, UserState } from "@/models/user";
import {
  getVirtualUserDetail,
  getIsAddFriends,
  saveEUserSetting,
  removeEFriend,
  getAllRelationShip,
  getUserEbookDetail,
  getTagList,
  setTag,
  setTagForEmpl
} from "@/api/ebook";
import { getRobotChangeUserDetailList } from "@/api/egroup";
import { getRobotDetail } from "@/api/appStore";
import { message as toast, message, Modal, Button } from "antd";
import React, { useCallback, useContext, useEffect, useState, useMemo } from "react";
import { AppState, ModalsState } from "@/models";
import { Session } from "@/types/chat";
import { connect } from "dvajs";
import log from "loglevel";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router-dom";
import Bus from "@/utils/bus";
import ImService from "@/server/ImService";
import { EbookState, MangeExternalModalInfo } from "@/models/ebook";
import { FocusSDK, isFocusEnv } from "@/utils";
import useShareUserCard from "@/components/Modals/useShareUserCard";
import lodashPick from "lodash/pick";
import { appliesNewContacts, openUserCardModal } from "@/components/AddressBook/common";
import { NetState } from "@/models/netStatus";
import {
  applyAddGroup,
  applyFriend,
  doAcceptFriend,
  getIsSelf,
  handleCreateGroupMeeting,
  handleCreateXCMeeting,
  joinGroup,
  launchSession,
  onClickAvatar,
  removeFriend,
  replyApplyMessage,
  startJrtc,
  startVoip
} from "../UserCard/common";
import ChatState from "@/types/chat/State";
import { setEmplFollow, setModifyFriend } from "@/api/chat";
import { analysisLog } from "@/utils/logAnalytics";
import { examineMobileRecord, remarkSet } from "@/api/addressBook";
import { UserCardV2 } from "@jd/focus-desktop-comps";
// import UserCard from "./UserCardV2";
import config, { ChatConfig, ConfigEnum } from "@/config/config";
// import { UserCardAction, UserCardData } from '@/types/UserCard';
import {
  UserCardAction,
  UserCardActionClickInfo,
  UserCardData
} from "@jd/focus-desktop-comps/lib/es/UserCard/UserCardType";
import { UserCardType } from "@/types/UserCard";
import AdministratorModal from "./AdministratorModal";
import useCommListener from "@/hooks/useCommListener";
import clientConfig, { ClientConfigEnum } from "@/config/clientConfig";
import { handleRemarkSet } from "@/utils/modals";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import { mapUserDataToUid } from "@/utils/chat/message";
import { AVSDK } from "@/baseComponents/Meeting/common";
import { pick, omit } from "lodash";
import { queryEmplReward } from "@/api/reward";
const logger = log.getLogger("UserCard");

interface Props {
  userData: UserModel;
  selectedSession: Session;
}
export interface contactRelation {
  friendship: number;
  relation: number;
  contactType: any;
  isEnableAddFriend: boolean;
  isOnlyScanAdd: boolean;
  isRemove: boolean;
}

type IProps = Readonly<Props & AppState & EbookState & ChatState>;

function UserCardModal(
  props: IProps & {
    pushChatMessage: Function;
    openCreateContactModal: Function;
    setOpenAdministratorListModal: Function;
    isMessageModule: boolean;
    modalsData?: ModalsState;
    updateCurrentEmployee: Function;
    manageExternalModal: MangeExternalModalInfo;
    setManageExternalModal: Function;
  } & NetState
) {
  const {
    userData,
    modals,
    currentEmployee,
    openCreateContactModal,
    newPublicResult,
    isMessageModule,
    modalsData,
    updateCurrentEmployee,
    manageExternalModal,
    setManageExternalModal
  } = props;
  const { userCard } = modalsData ? modalsData : modals;
  const {
    appId,
    userId,
    teamId,
    visible,
    type,
    needMask,
    needMaskName,
    robotData,
    notPersonalCalendar,
    footExtra
  } = userCard;
  const { t } = useTranslation("common");
  const [voipClick, SetVoipClick] = useState(false);
  const [friendErrMsg, setFriendErrMsg] = useState<string>("");
  const [isfriend, setIsFriend] = useState<number>(-1);
  const [visibleFriends, setVisibleFriends] = useState(false);
  const [infoLoaded, setInfoLoaded] = useState(false);
  const [contactRelationship, setContactRelationship] = useState<contactRelation>({
    contactType: null,
    friendship: 1,
    isEnableAddFriend: true,
    isOnlyScanAdd: false,
    relation: 1,
    isRemove: false
  });
  const [visibleAdministrator, setVisibleAdministrator] = useState({ visible: false, type: "" });

  const history = useHistory();
  console.log("histroey===", history);

  const location = useLocation();
  useCommListener("userCard", modals.userCard.visible);

  const shareUserCard = useShareUserCard({ userData, currentEmployee });
  const { isHomePage } = useContext<GlobalContextConfig>(GlobalContext);
  useEffect(() => {
    if (FocusSDK.isPrivateNet()) {
      FocusSDK.checkUrlOnline({
        type: "zoomNet",
        isPrivateNet: true
      });
    }
  }, []);

  useEffect(() => {
    if (!visible) {
      setInfoLoaded(false);
    }
  }, [visible]);

  const closeCard = () => {
    Bus.emit("app:toggle-user-card-modal:hide", {});
  };

  const doShowAdministrator = useCallback((type) => {
    setVisibleAdministrator({ visible: true, type });
  }, []);

  const handleSetEmplFollow = useCallback(async (params) => {
    const [res, err] = await setEmplFollow(params);
    if (!err) {
      const imService = ImService.getInstance();
      await imService.updateEmployee([
        {
          pin: params.userIds[0].userId,
          teamId: params.userIds[0].teamId,
          app: params.userIds[0].appId
        }
      ]);
    }
    return [res, err];
  }, []);

  const doSwitchAdministrator = useCallback(() => {
    setVisibleAdministrator({
      ...visibleAdministrator,
      visible: false
    });
  }, [visibleAdministrator]);

  const actionClick = async (props: UserCardActionClickInfo) => {
    const { type, data, accessPhone, replyMsg = "", applyId = 0, flag = 0, reply = 0 } = props;
    const avatar = data?.fields?.find((i: any) => i.key === "avatar");
    const name = data?.fields?.find((i: any) => i.key === "name");
    openCreateContactModal({ visible: false }); // 添加联系人modal关闭
    Bus.emit("onHideUserCenter"); // 系统管理员列表modal关闭
    if (manageExternalModal.visible) setManageExternalModal({ visible: false });
    switch (type) {
      case UserCardAction.Chat:
        if (!isHomePage) {
          const { app, pin, teamId } = mapUserDataToUid(data);
          const path = `/messages/s/${pin}?app=${app}&tid=${teamId}`;
          FocusSDK.launchNewSession(path);
          Bus.emit("app:toggle-user-card-modal:hide");
        } else {
          launchSession(data, location, history);
        }
        Bus.emit("onHideGlobalSearch");
        return;
      case UserCardAction.Send:
        return await applyFriend(data, accessPhone, currentEmployee);
      case UserCardAction.Accept:
        return await doAcceptFriend(data, accessPhone, currentEmployee);
      case UserCardAction.AddGroup:
        return await applyAddGroup(data as any, currentEmployee);
      case UserCardAction.JoinGroup:
        return await joinGroup(data as any, currentEmployee, history);
      case UserCardAction.Voip:
        if (clientConfig[ClientConfigEnum.JD_AUDIO]) {
          startJrtc(data, currentEmployee, "voice");
          return;
        }
        handleCreateGroupMeeting(data, currentEmployee);
        return;
      case UserCardAction.Jrtc:
        if (!isHomePage) {
          FocusSDK.sendToMain("ai:mt:single:meeting:create", {
            from: {
              app: currentEmployee.app,
              teamId: currentEmployee.teamId,
              pin: currentEmployee.userId,
              avatar: currentEmployee.avatar,
              name: currentEmployee.name
            },
            to: {
              pin: data.userId,
              teamId: data.teamId,
              app: data.appId,
              avatar: avatar?.val,
              name: name?.val
            },
            avsdk: AVSDK.JBRTC,
            type: ""
          });
        } else {
          startJrtc(data, currentEmployee);
        }
        Bus.emit("onHideGlobalSearch");
        return;
      case UserCardAction.Meeting:
        if (!isHomePage) {
          FocusSDK.sendToMain("ai:mt:group:meeting:create", {
            to: data,
            from: currentEmployee,
            netState: newPublicResult
          });
        } else {
          handleCreateGroupMeeting(data, currentEmployee, newPublicResult);
        }
        Bus.emit("onHideGlobalSearch");
        return;
      case UserCardAction.Share:
        closeCard(); // 关闭名片页弹窗
        return await shareUserCard(data as any);
      case UserCardAction.XCMeeting:
        await handleCreateXCMeeting(data as any);
        Bus.emit("onHideGlobalSearch");
        return;
      case UserCardAction.Deleted:
        await removeFriend(data, currentEmployee);
        return;
      case UserCardAction.UnitAdministrator:
        closeCard();
        doShowAdministrator("unitAdministrator");
        return;
      case UserCardAction.Administrator:
        closeCard();
        doShowAdministrator("Administrator");
        return;
      case UserCardAction.Reply:
        return await replyApplyMessage({ data, currentEmployee, replyMsg, applyId, flag, reply });
      default:
        break;
    }
    // if (isFocusEnv()) {
    //     return { close: true, data: true };
    // }
    // return true;
    return { close: true, data: true };
  };

  const isRobot = useMemo(() => userId?.startsWith("robot_"), [userId]);

  useEffect(() => {
    if (!appId || !userId || !teamId) {
      return;
    }
    setIsFriend(-1);
    setFriendErrMsg("");
    setVisibleFriends(false);
    // app相同 teamId相同，可以直接会话
    // if (appId === currentEmployee.app && teamId === currentEmployee.teamId) {
    //     setIsFriend(true);
    //     return;
    // }
    getIsFriends(appId, userId, teamId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appId, userId, teamId]);

  async function getIsFriends(appId: string, userId: string, teamId: string) {
    let AllRelationShip: any = {};
    let err = null;
    if (isRobot) {
      AllRelationShip = {
        friendShip: 0,
        relation: 1,
        isEnableAddFriend: false,
        isOnlyScanAdd: false,
        contactType: null
      };
    } else {
      [AllRelationShip, err] = await getAllRelationShip({
        oppoUserId: userId,
        oppoTeamId: teamId,
        appId
      });

      log.info("getAllRelationShip", AllRelationShip, err);
      if (err) {
        setFriendErrMsg(err);
        return;
      }
    }
    const { contactType, friendship, isEnableAddFriend, isOnlyScanAdd, relation } = AllRelationShip;

    // 是否可添加好友 isEnableAddFriend
    // 好友关系 friendship
    // 同事关系 relation
    // 是否只能扫码添加 isOnlyScanAdd
    // 联系人类型 contactType
    setContactRelationship({
      ...AllRelationShip,
      isRemove:
        (friendship === 1 || friendship === 8) && !getIsSelf(userData, userCard) ? true : false
    });

    // friendShip:0无友谊（路人），1好友，2黑名单，4被关注（B的好友列表中有A，但是A的好友列表没有B），8单相思（A的好友列表有B，但是B的好友列表没有A）
    // relation:1同事，2陌生人

    // isEnableAddFriend  false 不需要加好友 有可见关系(可见)  true 需要加好友 没有可见关系(不可见)
    // 好友关系如果可见 并且 是同事或者好友 不用添加好友

    if (isEnableAddFriend === false) {
      // 组织可见联系人进行添加联系人的操作
      if (friendship === 1 || friendship === 8) {
        setIsFriend(1);
        return;
      } else if (friendship === 0 || friendship === 4) {
        setVisibleFriends(true);
        setIsFriend(1);
        return;
      } else {
        setIsFriend(0);
        return;
      }
    } else {
      if (friendship === 1 || friendship === 8 || getIsSelf(userData, userCard)) {
        setIsFriend(1);
        return;
      } else if (friendship === 0 || friendship === 4) {
        setIsFriend(0);
        return;
      }
    }
  }

  useEffect(() => {
    const listener = ({ close, data }: any) => {
      // logger.debug('open-user-card listener 1111 ==>', data, close);
      actionClick({ type: data.action, data }).then((result) => {});
    };
    Bus.on("open-user-card", listener);

    return () => {
      Bus.off("open-user-card", listener);
    };
  }, [history]); // eslint-disable-line
  const onSetTag = useCallback((params) => {
    analysisLog("xtbg_address_home_1722323222167", "3");
    return setTag(params);
  }, []);
  const onSetTagForEmpl = useCallback((params) => {
    if (params.tagIds?.length) {
      analysisLog("xtbg_address_home_1722323222167", "4");
    } else {
      analysisLog("xtbg_address_home_1722323222167", "5");
    }
    return setTagForEmpl(params);
  }, []);
  // 关闭时 人员卡片全部销毁
  if (!visible) {
    if (visibleAdministrator.visible) {
      return (
        <AdministratorModal
          visible={visibleAdministrator.visible}
          onCancel={doSwitchAdministrator}
          type={visibleAdministrator.type}
        />
      );
    }
    return null;
  }

  const openBusyIdleViewDraw = (data: any) => {
    try {
      const params = pick(data, [
        "userId",
        "teamId",
        "appId",
        "userType",
        "labelInfoList",
        "mainTitleDeptInfo",
        "fields"
      ]);
      const { unitName = "", deptName = "", titleName = "" } = params?.mainTitleDeptInfo || "";
      Bus.emit("calendar:openBusyIdleViewDraw", {
        ...omit(params, ["appId", "mainTitleDeptInfo", "fields"]),
        app: params?.appId || "",
        ddAppId: params?.appId || "",
        realName: params?.fields?.find((item: any) => item.key === "name")?.val || "",
        titleName:
          (unitName ? unitName + "-" : "") + (deptName ? deptName + "-" : "") + (titleName || ""),
        headImg: params?.fields?.find((item: any) => item.key === "avatar")?.val || ""
      });
    } catch (error) {
      message.error("查看日历异常");
      FocusSDK.printLog(error);
    }
  };

  const triggerEvent = (type: string, data?: any) => {
    switch (type) {
      case "showCalendar":
        openBusyIdleViewDraw(data);
        break;
      case "showPublicEmplManagerCard":
      case "showPublicEmplUsageCard":
        closeCard();
        setTimeout(() => {
          openUserCardModal({
            teamId: teamId,
            userId: data.userId,
            app: appId
          } as any);
        }, 0);
        break;
      case "showEmplFollowList":
        Bus.emit("onHideGlobalSearch");
        Bus.emit("onHideUserCenter"); // 系统管理员列表modal关闭
        openCreateContactModal({ visible: false });
        if (history.location.pathname === "/systemSetting") {
          Bus.emit("navigateSystemSettingTab", {
            activeKey: "NotifySetting",
            showEmplFollowList: true
          });
        } else {
          history.push({
            pathname: "/systemSetting",
            state: {
              activeKey: "NotifySetting",
              showEmplFollowList: true
            }
          });
        }
        break;
      case "showDepartment":
        Bus.emit("onHideGlobalSearch");
        Bus.emit("onHideUserCenter"); // 系统管理员列表modal关闭
        openCreateContactModal({ visible: false });
        if (history.location.pathname === "/address_list") {
          Bus.emit("navigateDepartmentTab", {
            deptInfo: data
          });
        } else {
          history.push({
            pathname: "/address_list",
            state: {
              deptInfo: data
            }
          });
        }
        break;
      case "openUserCard":
        console.log("openUserCard:", data);
        console.log("userData:", userData);
        if (!data) break;
        Bus.emit("app:toggle-user-card-modal:hide");
        setTimeout(() => {
          Bus.emit("app:toggle-user-card-modal:show", {
            visible: true,
            type: UserCardType.User,
            teamId: teamId,
            userId: data,
            appId: userData.ddAppId || ""
          });
        }, 200);
        break;
      default:
        break;
    }
  };

  return (
    <Modal
      visible={visible}
      closable={false}
      onCancel={closeCard}
      footer={(infoLoaded && footExtra) || null}
      bodyStyle={{
        padding: 0
      }}
      wrapClassName="me-user-card-modal-v2"
      style={{
        width: 330
      }}
      mask={true}
      maskStyle={{
        backgroundColor: "transparent"
      }}
      destroyOnClose
    >
      <UserCardV2
        currentPage={history.location.pathname || ""}
        triggerEvent={triggerEvent}
        friendErrMsg={friendErrMsg}
        contactRelationship={contactRelationship}
        isfriend={isRobot ? 1 : isfriend}
        data={userCard}
        notPersonalCalendar={isRobot || notPersonalCalendar}
        currentEmployee={currentEmployee}
        setEmplFollow={handleSetEmplFollow}
        canAddContact={currentEmployee.teamId !== FocusSDK.getBjwpConfig()?.teamId}
        onActionClick={actionClick}
        onGetTagList={getTagList}
        onSetTagForEmpl={onSetTagForEmpl}
        onSetTag={onSetTag}
        onGetUserLevel={async (params: { userId: string; teamId: string; appId: string }) => {
          const res: any = {}; // await queryEmplReward(params);
          return {
            levelName: res?.currentLevel?.levelName || "",
            ext: res?.currentLevel?.ext || "",
            fileUrl: res?.currentLevel?.fileUrl || ""
          };
        }}
        openUserLevelDetail={(ext: string) => {
          console.log("ext==>>", ext);
        }}
        onGetUserInfo={async (params: {
          userId: string;
          teamId: string;
          appId: string;
          rootOrgId?: string;
        }) => {
          let result: any;
          console.log("getUserInfo~~~~~~");
          if (params.rootOrgId) {
            result = await getVirtualUserDetail(params);
          } else {
            // 姓名脱敏： 有可见性不脱敏，没有可见性脱敏
            if (needMask || needMaskName) {
              // 脱敏展示个人信息
              result = await getUserEbookDetail({
                ...lodashPick(params, ["appId", "userId", "teamId"]),
                isMulti: true,
                isFromBusinessCard: true,
                needMask,
                needMaskName
              });
            } else {
              const imService = ImService.getInstance();
              result = await imService.getEmployeeDetail({
                ...lodashPick(params, ["appId", "userId", "teamId"]),
                isFromBusinessCard: true
              });
            }

            if (getIsSelf(userData, result)) {
              let fields: any = {};
              (result?.fields || []).forEach((item: any) => {
                fields[item.key] = item.val;
              });
              updateCurrentEmployee({ ...result, ...fields });
            }
          }
          console.log("userCard result~~:", result);
          setInfoLoaded(true);
          if (isRobot && result) {
            const robotDetail: any = await getRobotDetail({ robotId: userId });
            if (robotDetail) {
              result.fields.push(
                {
                  hide: 0,
                  index: 0,
                  key: "developer",
                  name: "开发者",
                  val: robotDetail?.application?.developer || ""
                },
                {
                  hide: 0,
                  index: 0,
                  key: "brief",
                  name: "简介",
                  val: robotDetail?.brief || robotDetail?.application?.brief || ""
                }
              );
            }
            result.labelInfoList = [
              {
                color: "FB4C46",
                // index: 6,
                isShow: "1",
                label: "isRobot",
                labelEnum: "IS_ROBOT",
                name: "机器人"
              }
            ];
          }
          return result || null;
        }}
        onClickAvatar={onClickAvatar}
        appliesNewContacts={appliesNewContacts}
        hideUserCardModal={() => {
          Bus.emit("app:toggle-user-card-modal:hide");
        }}
        setModifyFriend={setModifyFriend}
        analysisLog={analysisLog}
        examineMobileRecord={examineMobileRecord}
        remarkSet={handleRemarkSet}
        isExternsContactsVideo={config[ConfigEnum.CHAT_SESSION_CREATE_JD_VIDEO_ENABLE]}
        isMessageModule={isMessageModule}
        isExternsContacts={!config[ConfigEnum.EXTERNAL_CONTACTS_ADD_CONTACTS]}
        buttons={
          type === UserCardType.CustomUser
            ? {
                add: visibleFriends
              }
            : isRobot
            ? { chat: true, share: isHomePage }
            : {
                chat: true,
                voip:
                  isHomePage && isFocusEnv() && config[ChatConfig.CHAT_SESSION_CREATE_VOIP_ENABLE],
                video: isFocusEnv() && config[ConfigEnum.CHAT_SESSION_CREATE_JD_VIDEO_ENABLE],
                webVideo: !isFocusEnv() && config[ConfigEnum.CHAT_SESSION_CREATE_JD_VIDEO_ENABLE],
                share: isHomePage,
                add: visibleFriends
              }
        }
      />
    </Modal>
  );
}

function mapStateToProps({
  user,
  app,
  chat,
  ebook,
  netStatus
}: {
  chat: ChatState;
  user: UserState;
  app: AppState;
  ebook: EbookState;
  netStatus: NetState;
}) {
  return {
    userData: user.userData.user,
    modals: app.modals,
    currentEmployee: chat.currentEmployee,
    selectedSession: chat.selectedSession,
    newPublicResult: netStatus.newPublicResult,
    newPrivateResult: netStatus.newPrivateResult,
    isMessageModule: chat.isMessageModule,
    manageExternalModal: ebook.manageExternalModal
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    openCreateContactModal(data: any) {
      dispatch({ type: "ebook/openCreateContactModal", payload: data });
    },
    setOpenAdministratorListModal(payload: boolean) {
      dispatch({ type: "ebook/setOpenAdministratorListModal", payload });
    },
    openCreateAddUserLabelNameModel(data: any) {
      dispatch({ type: "ebook/openCreateAddUserLabelNameModel", payload: data });
    },
    updateCurrentEmployee(payload: any) {
      dispatch({ type: "chat/updateCurrentEmployee", payload });
    },
    setManageExternalModal(payload: boolean) {
      dispatch({ type: "ebook/setManageExternalModal", payload });
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(UserCardModal);
